// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2QBjv","image":"Header_image__1JjDf","name":"Header_name__3EsOD","info":"Header_info__1c_fJ","infoRow":"Header_infoRow__38nkX"};